import { useState, useEffect } from 'react';

/**
 * Hook to detect if app is running on mobile device or installed as PWA
 * Returns true if:
 * 1. Device is mobile (screen width < 768px)
 * 2. App is installed as PWA (standalone mode)
 */
export const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Check if running as PWA (installed app)
      const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
                    window.navigator.standalone === true;
      
      // Check if device is mobile based on screen width
      const isMobileDevice = window.innerWidth < 768;
      
      // Check user agent for mobile devices
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

      // Consider it mobile if it's PWA OR mobile device OR mobile user agent
      setIsMobile(isPWA || isMobileDevice || isMobileUA);
    };

    // Initial check
    checkMobile();

    // Listen for window resize
    window.addEventListener('resize', checkMobile);

    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', checkMobile);
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', checkMobile);
      }
    };
  }, []);

  return isMobile;
};

/**
 * Check if app is running as installed PWA
 */
export const isPWAInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

/**
 * Check if device is mobile based on user agent
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
